var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ContactActivity"},[(_vm.numPages > 1)?_c('div',{staticClass:"num-pages whitespace-nowrap"},[_c('Icon',{attrs:{"type":"far","name":"copy"}}),_vm._v(" "+_vm._s(_vm.numPages)+" Pages ")],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }